<div class="max-width-p">
    <div class="mt-2 mb-4">
        <benefit-header-summary [headerText]="'CASHBACK.LIST_PAGE.TITLE' | translate"
                                [showBudgetCard]="false"></benefit-header-summary>
    </div>


    <div class="content">
        <p>{{ 'CASHBACK.LIST_PAGE.SUBTITLE' | translate }}</p>
    </div>

    <div class="row">
        <div class="col-lg-3">
            <app-cashback-shop-filter
            *ngIf="shopsCategory?.length"
            [categories]="shopsCategory"
            [applyFiltersBtnEnabled]="filtersOutdated"
            (changeFilters)="changeFilters($event)"
            (applyFilters)="applyFilters()"
            (resetFilters)="resetAllFilters()">
          </app-cashback-shop-filter>
        </div>
        <div class="col-lg-9 flexbile-benefit-cards">
            <div class="flex-column dd">
                <div class="medical-cards">
                    <div
                            class="card clickable"
                            *ngFor="let shop of filteredCollection"
                            (click)="navigateToDetails(shop.id)"
                    >
                        <div class="align-items-center justify-content-center d-flex">
                            <div *ngIf="shop.logo; else noPicture" style="height: 97px;">
                                <img
                                        [src]="shop.logo"
                                        alt="" role="presentation"
                                        style="max-width: 100%; max-height: 100%;"
                                />
                            </div>
                            <ng-template #noPicture>
                                <img src="assets/images/avatars/no-image.jpg"/>
                            </ng-template>
                        </div>
                        <div class="card-body">
                            <h4 class="card-title">{{ shop.name }}</h4>
                            <a href="javascript:void(0)" class="card-link c-company"
                            >{{ 'FLEXIBLE_FIXED_BENEFITS.VIEW' | translate }} {{ shop.couponCount + (shop.hasCashback ? 1 : 0) + ' ' }}
                                {{
                                    (shop.couponCount > 1
                                            ? 'FLEXIBLE_FIXED_BENEFITS.TEXT_OFFERS'
                                            : 'FLEXIBLE_FIXED_BENEFITS.TEXT_OFFER'
                                    ) | translate
                                }}
                                <span class="icon-chevron-right feather ficon"></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
